import type { TransactionActionCapabilityDefinition } from '../../capabilities';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import { parseRenamePayeeAssistantResponse } from './validators';

// Capability definition (plugin-contract step 1 in docs/features/transaction-actions/README.md):
// registers rename_payee's runner id, execution profile, and structured-response parser with the
// framework's capability registry (see ../../capabilities.ts).
export const renamePayeeTransactionActionCapability: TransactionActionCapabilityDefinition = {
  capability: 'rename_payee',
  supportedInPhase1: true,
  executionProfile: transactionActionExecutionProfiles.rename_payee,
  runnerId: 'structured_model',
  parseStructuredResponse: parseRenamePayeeAssistantResponse,
};
